import React from "react";
import "./JourneySection.scss";

import journeyImg1 from "../../../assets/images/Mask group.png";
import journeyImg2 from "../../../assets/images/Mask group (1).png";
import journeyImg3 from "../../../assets/images/Mask group (2).png";

const JourneySection = () => {
  return (
    <div className="journeySection-container">
      <h3>Our Data Journey</h3>
      <p>
        Maecenas facilisis aliquam neque, id malesuada ex. Maecenas nunc risus,
        malesuada et cursus quis, fringilla quis dui. Vestibulum tincidunt
        posuere mauris id consectetur. Mauris a justo nulla. Donec eu eros
        ultricies, viverra metus a, tincidunt purus. Sed scelerisque ullamcorper
        turpis ut condimentum.
      </p>
      <div className="journeySection-inner-container">
        <div className="journeySection-bgtop-container"></div>

        <div className="journeySection-cards-container">
          <div className="journeySection-cards-box">
            <div className="journeyImg-box">
              <img src={journeyImg1} alt="" />
            </div>
            <h4>Inception of Data Analytics</h4>
            <p>
              Cras convallis ligula vel lectus consectetur, at mattis nibh
              auctor. Curabitur sodales commodo elit, at vehicula arcu
              pellentesque pulvinar.{" "}
            </p>
          </div>
          <div className="journeySection-cards-box">
            <div className="journeyImg-box">
              <img src={journeyImg2} alt="" />
            </div>
            <h4>Sources and Integration</h4>
            <p>
               Phasellus eu tortor lectus. Phasellus luctus dui in turpis rutrum
              facilisis dapibus nec mauris. Aliquam bibendum lectus magna, quis
              bibendum massa.
            </p>
          </div>
          <div className="journeySection-cards-box">
            <div className="journeyImg-box">
              <img src={journeyImg3} alt="" />
            </div>
            <h4>Transforming Raw Data into Insights</h4>
            <p>
              Nullam magna lorem, elementum vel ligula mollis, tempus
              condimentum ex. Integer ut sapien condimentum, luctus mi sit amet,
              tempus elit.
            </p>
          </div>
        </div>

        <div className="d-flex justify-content-center mt-5">
          <a href="/viewdetails">
            {" "}
            <button className="theme-Btn-bg mt-5">
              <span> View Details</span>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default JourneySection;
